type StripTagsFn = (
    html: string,
    allowedTags?: string | string[],
    tagReplacement?: string,
) => string;

// CJS package (`export =`); avoid `import = require` (Babel) and default import (needs esModuleInterop).
const striptags: StripTagsFn = require('striptags');

export const stripHtml = (html: string): string => {
    return striptags(html);
};

export function stripHtmlToText(html: string): string {
    if (!html) return "";

    return striptags(html, [], " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\u00a0/g, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, `"`)
        .replace(/&#39;/gi, `'`)
        .replace(/\s+/g, " ")
        .trim();
}

export function hasHtmlText(html: string | null | undefined): boolean {
    return stripHtmlToText(String(html || "")).length > 0;
}

/** True when HTML has visible text and/or media (images, tables, etc.). */
export function hasHtmlContent(html: string | null | undefined): boolean {
    const raw = String(html || "");
    if (!raw.trim()) return false;
    if (hasHtmlText(raw)) return true;
    return /<(img|video|iframe|table|svg)\b/i.test(raw);
}
